import React from 'react'
import { Link } from "react-router-dom";

const ProductoOpcionItem = (props) => {
  return <li className="list-group-item align-middle">
            <img className="col-3 float-left" width="20%" src={"https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/productos%2F" + props.item.img + ".png?alt=media"} alt={props.item.nombre} />
            <img className="col-3 float-left" width="20%" src={"https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/custom%2F" + props.item.id + ".png?alt=media"} alt={props.item.nombre} />
            <hgroup className="col-5 float-right">
              <p>
            <Link to={'/admin/opcion/' + props.cat+'/' + props.item.id}>{props.item.nombre}<br/><small>{props.item.id}</small></Link>
              </p>
            </hgroup>
          </li>;
}

export default ProductoOpcionItem




// WEBPACK FOOTER //
// ./src/components/producto_opcion_admin.js